/* oxlint-disable no-inner-declarations */
import * as rq from '@tanstack/react-query';

import { appConfig } from '@/config';
import { useAuth } from '@/hooks/use-auth';
import { useMe } from '@/hooks/use-me';

import { mixedV1ResetCreate } from '../../__generated__/oazapfts-client';

export namespace GlobalResetDemo {
  export type Input = void; // No parameters needed
  export type Output = void;

  export function useMutation() {
    const auth = useAuth();
    const me = useMe();
    const queryClient = rq.useQueryClient();

    return rq.useMutation<Output, unknown, Input>({
      async mutationFn() {
        const accessToken = await auth.getAccessToken();

        const result = await mixedV1ResetCreate(
          {
            xUserEmail: me.email,
            xUserName: me.displayName,
          },
          {
            baseUrl: `${appConfig.bffUrl}/plex`,
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          },
        );

        if (result.status !== 200) {
          throw new Error(`Failed to reset demo: ${result.status}`);
        }

        return;
      },
      async onSuccess() {
        // Invalidate all queries to refresh the entire app state
        await queryClient.invalidateQueries();
      },
    });
  }
}
